import { combineReducers } from 'redux';
import exampleFlow from './exampleFlow';
import { FlowId } from '@constants/flows';

const flowReducers = {
  [FlowId.EXAMPLE]: exampleFlow,
};

export default combineReducers(flowReducers);
